import { useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

import UnauthenticatedPage from '@components/pageTypes/UnauthenticatedPage';
import TwoFactorAuthentication from '@components/TwoFactorAuthentication';
import useMyClient from '@hooks/useMyClient';

const TwoFactorAuthenticationPage = () => {
  const myClient = useMyClient();
  const intl = useIntl();
  const contentRef = useRef<HTMLIonContentElement>(null);

  return (
    <UnauthenticatedPage contentRef={contentRef} image="mapBusSelfie">
      <Helmet>
        <title>{intl.formatMessage({ id: 'pageTitles.auth.twoFactorAuthentication.verify' })}</title>
      </Helmet>
      <TwoFactorAuthentication client={myClient} />
    </UnauthenticatedPage>
  );
};

export default TwoFactorAuthenticationPage;
